module.exports = __webpack_public_path__ + "img/childhoodcancer.6ed80ce.png";